export default "__VITE_ASSET__qk1y9asA__"